import {
    type InsightsMetricsMap,
    type MetricFieldsUnion,
    type StatsItem,
    createDefaultInsightsMetrics,
} from "../models";

export const generateDefaultMetrics = (metricsList: MetricFieldsUnion[]): InsightsMetricsMap<StatsItem> => {
    return Object.fromEntries(metricsList.map((metric) => [metric, createDefaultInsightsMetrics(metric)]));
};
